import styled from 'styled-components';

const ButtonType = styled.span`
    color: ${ ({ color, theme }) => (color ? color : theme.semanticColor.textPrimary) };
    font-family: ${ ({ theme }) => theme.type.semiBoldFont };
    font-size: 14px;
    letter-spacing: 0.4px;
    line-height: 18px;
`;

export default ButtonType;
